import i18n from 'app/i18n/i18n'
import SOCIAL_CONTACT_LINKS from 'constants/SOCIAL_CONTACT_LINKS'

export const SUPPORT_CONTACTS = {
  get schedule() { return i18n.t('Weekdays: from 10:00 to 19:00 MSK') },
  telegram: {
    get title() { return i18n.t('Chat with support in Telegram') },
    href: 'https://t.me/sportvokrug_support',
  },
  whatsapp: {
    get title() { return i18n.t('Chat with support in WhatsApp') },
    href: 'https://wa.me/79623691102',
  },
  phone: {
    title: '8 (800) 7777 678',
    href: 'tel:88007777678',
  },
  email: {
    title: 'support@sportvokrug.ru',
    href: 'mailto:support@sportvokrug.ru',
  },
  mediaEmail: {
    title: 'media@sportvokrug.ru',
    href: 'mailto:media@sportvokrug.ru',
  },
  projects: {
    get title() { return `${window.location.protocol}//${window.location.hostname}/projects/` },
    href: '/projects/',
  },
}

export const SOCIAL_CONTACTS = {
  telegram: {
    title: '@sportvokrug_official',
    href: SOCIAL_CONTACT_LINKS.telegram,
  },
  vk: {
    get title() { return i18n.t('VKontakte') },
    href: SOCIAL_CONTACT_LINKS.vk,
  },
  youtube: {
    title: 'YouTube',
    href: SOCIAL_CONTACT_LINKS.youtube,
  },
}
